@switch (creatorService.currentStep) {
  @case (1) {
    <app-graduation-message-step1></app-graduation-message-step1>
  }
  @case (2) {
    <app-graduation-message-step2></app-graduation-message-step2>
  }
  @case (3) {
    <app-graduation-message-step3></app-graduation-message-step3>
  }
}
